import { render } from "./ArticlesAboutUs.vue?vue&type=template&id=8a0165e8"
import script from "./ArticlesAboutUs.vue?vue&type=script&lang=js"
export * from "./ArticlesAboutUs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev_storage\\webs\\tc_web\\web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__